export default __webpack_public_path__ + "static/media/shipment.a73bfa08.svg";